@if (verfahrenList | async; as _verfahrenList) {
	<div #verfahrenRoot class="x-section" [attr.data-help-anchor]="isListOfLastOpenedVerfahren ? '_letzte_verfahren': '_verfahrenssuche'">
		<div class=" x-section__headline">
			<h2 class="mat-h1 " tabindex="0">{{ isListOfLastOpenedVerfahren ? 'Zuletzt geöffnete Verfahren' : 'Verfahren' }}</h2>
		</div>
		<div class="x-section__subline">
			<i class=" material-icons" aria-hidden="true">folder</i>
			@if (!isListOfLastOpenedVerfahren) {
				<div class="mat-body">Anzahl:
					@if (_verfahrenList.resource) {
						<span data-test-id="result-counter">{{ _verfahrenList.resource.page.totalElements }}</span>
					}
					<span class="visually-hidden" role="alert">{{ audioAlert | async }}</span>
				</div>
			}
			@if (_verfahrenList.resource | hasResourceLink: 'add') {
				<schir-int-client-button-round popup="dialog" toolTip="Neues Verfahren anlegen"
				                               (click)="openCreateVerfahrenDialog()"
				                               data-test-id="create-verfahren-button" materialIcon="add"
				                               cssClass="focus-inwards-light schir-midi-button" class="add"/>
			}
		</div>
		<schir-int-client-verfahren-list [verfahren]="_verfahrenList" class="x-section__main"
		                                 data-test-id="verfahren-list-root"/>
	</div>
}
